// src/components/LoadingSpinner.js
import React from 'react';

const Spinner = () => (
    <div className="loading-spinner">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{
                margin: 'auto',
                background: 'transparent',
                display: 'block',
                shapeRendering: 'auto',
            }}
            width="200px"
            height="200px"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
        >
            {[...Array(12)].map((_, i) => (
                <g key={i} transform={`rotate(${i * 30} 50 50)`}>
                    <rect
                        x="47"
                        y="24"
                        rx="3"
                        ry="6"
                        width="6"
                        height="12"
                        fill="#dbe120"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin={`${-i * 0.083333}s`}
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
            ))}
        </svg>
    </div>
);

export default Spinner;
